import { render } from "./ModalMultipleProductsBarcode.vue?vue&type=template&id=ec80f962"
import script from "./ModalMultipleProductsBarcode.vue?vue&type=script&lang=js"
export * from "./ModalMultipleProductsBarcode.vue?vue&type=script&lang=js"

import "./ModalMultipleProductsBarcode.vue?vue&type=style&index=0&id=ec80f962&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__